import {Trash} from "react-bootstrap-icons";
import React from "react";

import "./DeleteButton.css"

export function DeleteButton({ show, handleDelete, shouldLimitWidth }) {

    return (
        <div className={`delete-button ${show ? 'show' : ''} ${shouldLimitWidth ? 'limit-width' : ''}`}>
            <button
                className="btn btn-danger d-flex align-items-center justify-content-center"
                onClick={handleDelete}
            >
                <Trash/>
            </button>
        </div>
    );
}